/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateQuoteRequestPost } from '../../models/create-quote-request-post';
import { CreateQuoteResponse } from '../../models/create-quote-response';

export interface QuotesControllerCreateQuote$Params {
      body: CreateQuoteRequestPost
}

export function quotesControllerCreateQuote(http: HttpClient, rootUrl: string, params: QuotesControllerCreateQuote$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateQuoteResponse>> {
  const rb = new RequestBuilder(rootUrl, quotesControllerCreateQuote.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateQuoteResponse>;
    })
  );
}

quotesControllerCreateQuote.PATH = '/planning-projects/v1-develop/quotes';
